import { generatePath } from 'react-router-dom'
import { ALL_FILES_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Recent } from 'blaze-ui/icons'
import Styles from '../NavMenu.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuAllFilesItem = ({ workspaceId, onPress }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { isMobile } = useResponsiveDesign()

  return (
    <NavMenuItem
      size="md"
      icon={Recent}
      activeIcon={({ color }: { color?: string }) =>
        isSystemRedesignEnabled ? (
          <Recent color={color} size={15} />
        ) : (
          <div className={Styles.iconFilled}>
            <Recent color={color} size={isMobile ? 24 : 20} />
          </div>
        )
      }
      to={generatePath(ALL_FILES_PATH, { workspaceId })}
      onPress={onPress}
      label={isSystemRedesignEnabled ? 'Recents' : 'Recent'}
    />
  )
}

export { NavMenuAllFilesItem }
